import Base from './Base';
import Helper from '../Helper';
import Option from '../../Components/Widgets/Option.svelte';
import Product from '../../Stores/Product';

export default class Bundle extends Base {
	build(list, property) {
		if (property.visible) {
			const selected = property.selected || {};

			let items = [];
			for (let item of property.bundle_items) items.push(item.name);
			items = items.join('</b></li><li><b>');
			const intro = 'Deze voordeelbundel bevat de volgende producten:';
			const description = `${intro} <ul><li><b>${items}</b></li></ul>`;

			list.push({
				component: Option,
				config: {
					id: property.id,
					checked: selected.value === property.id,
					title: property.name,
					badge: property.badge,
					price: property.price || Product.variationPercentage(property.percentage),
					price_high: property.price_from || 0,
					description,
					on_click: item => {
						const checked = selected.value === property.id;
						if (!checked) {
							const properties = this.product().step.properties;
							for (let current of properties)
								if (property.group === current.group)
									if (current.selected)
										current.selected = false;
						}

						property.selected = checked ? false : item;
						this.update();
					}
				}
			});
		}

		return list;
	}
}